import './App.css';
import {useState} from 'react';
import QrCodeCanvas from './QrCodeCanvas';

function App() {
  const [text, setText] = useState("");

  return (
    <div className="App">
      <div className="container">
        <div className="header">
          <h1 className="title">Gerador de QR Code</h1>
          <p className="subtitle">Digite uma URL, texto ou qualquer informação para gerar seu QR Code</p>
        </div>

        <div className="input-container">
          <div className="form__group field">
            <input 
              type="text" 
              className="form__field" 
              placeholder=" " 
              name="url" 
              id="url"  
              value={text}
              onChange={(e) => setText(e.target.value)} 
            />
            <label htmlFor="url" className="form__label">
              <span className="label-icon">🔗</span> URL ou Texto
            </label>
          </div>
        </div>

        <QrCodeCanvas text={text} />
      </div>
    </div>
  );
}

export default App;
